import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { TvSidecarState } from '../../lib/deepAnalysis/types';

export interface TvSidecarSliceState {
  state: TvSidecarState;
  lastCapturedAtMs: number;
  ageSeconds: number;
  ticker: string;
}

const initialState: TvSidecarSliceState = {
  state: 'not_installed',
  lastCapturedAtMs: 0,
  ageSeconds: 0,
  ticker: '',
};

const tvSidecarSlice = createSlice({
  name: 'tvSidecar',
  initialState,
  reducers: {
    setSidecarStatus: (
      state,
      action: PayloadAction<Partial<TvSidecarSliceState>>,
    ) => {
      const next = action.payload;
      if (next.state !== undefined) state.state = next.state;
      if (next.lastCapturedAtMs !== undefined) state.lastCapturedAtMs = next.lastCapturedAtMs;
      if (next.ageSeconds !== undefined) state.ageSeconds = next.ageSeconds;
      if (next.ticker !== undefined) state.ticker = next.ticker;
    },
    resetSidecarStatus: () => initialState,
  },
});

export const { setSidecarStatus, resetSidecarStatus } = tvSidecarSlice.actions;
export default tvSidecarSlice.reducer;
